module.exports = __webpack_public_path__ + "static/img/radio_stop.053f735e.svg";